import { useEffect, useState, type ComponentType } from 'react';
import { useParams } from 'react-router-dom';
import { PageLoader } from './PageLoader';
import NotFound from '../pages/NotFound';

const localComponents: { [key: string]: () => Promise<any> } = {
  home: () => import('../pages/Home'),
  about: () => import('../pages/About'),
  contact: () => import('../pages/Contact'),
};

const DynamicPage = () => {
  const { slug = 'home' } = useParams<{ slug: string }>();
  const isLocal = slug in localComponents;

  const [LocalComponent, setLocalComponent] = useState<ComponentType | null>(null);
  const [loading, setLoading] = useState(isLocal);

  useEffect(() => {
    setLocalComponent(null);
    setLoading(isLocal);

    if (!isLocal) return;

    localComponents[slug]()
      .then(mod => {
        setLocalComponent(() => mod.default);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [slug, isLocal]);

  if (isLocal) {
    if (loading) return <PageLoader />;
    if (LocalComponent) return <LocalComponent />;
  }

  return <NotFound />;
};

export default DynamicPage; 